import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import { Button, Input } from '@gisatcz/ptr-atoms';
import { withNamespaces } from '@gisatcz/ptr-locales';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoginOverlay = function LoginOverlay(_ref) {
  var onClose = _ref.onClose,
      onLogin = _ref.onLogin,
      open = _ref.open,
      opening = _ref.opening,
      loginRequired = _ref.loginRequired,
      t = _ref.t;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      password = _useState4[0],
      setPassword = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openState = _useState6[0],
      setOpen = _useState6[1];

  useEffect(function () {
    if (opening) {
      setTimeout(function () {
        setOpen(true);
      }, 10);
    }
  }, []);

  var onChangeEmail = function onChangeEmail(value) {
    setEmail(value);
  };

  var onChangePassword = function onChangePassword(value) {
    setPassword(value);
  };

  var closeOverlay = function closeOverlay() {
    setOpen(false);

    if (onClose) {
      setTimeout(function () {
        onClose();
      }, 350);
    }
  };

  var login = function login() {
    onLogin(email, password);
    closeOverlay();
  };

  var cancel = function cancel() {
    closeOverlay();
  };

  return /*#__PURE__*/_jsx("div", {
    className: classNames('ptr-login-overlay', {
      open: openState || open
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: "ptr-login",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Input, {
          inverted: true,
          email: true,
          transparent: true,
          placeholder: "E-mail",
          onChange: onChangeEmail,
          value: email
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Input, {
          inverted: true,
          password: true,
          transparent: true,
          placeholder: t('user.passphrase'),
          onChange: onChangePassword,
          value: password
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          primary: true,
          onClick: login,
          children: t('user.login')
        }), !loginRequired ? /*#__PURE__*/_jsx(Button, {
          invisible: true,
          inverted: true,
          onClick: cancel,
          children: t('cancelCapitalized')
        }) : null]
      })]
    })
  });
};

LoginOverlay.propTypes = {
  onClose: PropTypes.func,
  onLogin: PropTypes.func,
  open: PropTypes.bool,
  opening: PropTypes.bool,
  loginRequired: PropTypes.bool,
  t: PropTypes.func
};
export default withNamespaces(['common'])(LoginOverlay);